import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import getAPI from "../../service/getAPI";
import axios from "axios";

function Login() {
  const { master } = getAPI();
  const navigate = useNavigate();

  // 🟢 1. Extract the core API logic into a reusable function
  const performLogin = async (username, password) => {
    try {
      const payload = {
        mobile_no: username,
        password: password,
      };

      const res = await axios.post(master.storeLogin, payload);

      if (res.status === 200 && res.data.flag === 1) {
        const userData = res.data.data[0];
        localStorage.setItem("user", JSON.stringify(userData));
        localStorage.setItem("token", userData.token);
        
        // Handle store_id and user_type from JWT token payload or user object
        const store_id = userData.store_id || 0;
        const user_type = userData.emp_type || userData.type || 'store';
        
        localStorage.setItem("store_id", store_id);
        localStorage.setItem("user_type", user_type);

        navigate("/admin/orderList");
      } else {
        alert(res.data.message || "Login failed!");
      }
    } catch (err) {
      console.error("Error during login:", err);
      alert("Server error, please try again.");
    }
  };

  useEffect(() => {
    // Check if session already exists
    const userSession = localStorage.getItem("user");
    if (userSession) {
      navigate("/admin/orderList");
      return;
    }

    // 🟢 2. Check for Secure Auto-Login URL Parameters (from Flutter)
    const urlParams = new URLSearchParams(window.location.search);
    const autoToken = urlParams.get("token");
    const autoUserBase64 = urlParams.get("user");

    if (autoToken && autoUserBase64) {
      try {
        // Decode the base64 user JSON
        const decodedUserStr = atob(autoUserBase64);
        const userObj = JSON.parse(decodedUserStr);

        // Save exactly as performLogin does
        localStorage.setItem("user", JSON.stringify(userObj));
        localStorage.setItem("token", autoToken);

        const store_id = userObj.store_id || 0;
        const user_type = userObj.emp_type || userObj.type || 'store';
        
        localStorage.setItem("store_id", store_id);
        localStorage.setItem("user_type", user_type);

        // SECURITY: Wipe credentials from URL
        window.history.replaceState({}, document.title, window.location.pathname);

        // Jump straight to the dashboard without hitting the login API!
        navigate("/admin/orderList");
        return;
      } catch (err) {
        console.error("Failed to parse auto-login parameters", err);
      }
    }

    // Fallback for old insecure method (can be removed later)
    const autoUser = urlParams.get("username");
    const autoPass = urlParams.get("password");

    if (autoUser && autoPass) {
      window.history.replaceState({}, document.title, window.location.pathname);
      performLogin(autoUser, autoPass);
    }
  }, [navigate]);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // 🟢 3. The manual form submit just calls our new function
  const onSubmit = (formData) => {
    performLogin(formData.username, formData.password);
  };

  return (
    <main>
      <div className="container">
        <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex flex-column align-items-center py-4">
                  <img
                    src="/assets/img/bilipatra_logo.png"
                    alt="Logo"
                    style={{ width: "200px", height: "150px" }}
                  />
                  <span className="d-block text-center mt-2 fs-5 fw-bold">
                    BILIPATRA BY
                  </span>
                  <span className="d-block text-center mt-2 fs-5 fw-bold">
                    Vraj Prachin Ayurved Chikitsa Kendra
                  </span>
                </div>
                <div className="card mb-3">
                  <div className="card-body">
                    <div className="pt-4 pb-2">
                      <h5 className="card-title text-center pb-0 fs-4">
                        Login to Your Account
                      </h5>
                    </div>
                    <form
                      className="row g-3 needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <div className="col-12">
                        <label htmlFor="yourUsername" className="form-label">
                          Username
                        </label>
                        <div className="input-group has-validation">
                          <input
                            type="text"
                            name="username"
                            className={`form-control ${errors.username ? "is-invalid" : ""}`}
                            id="yourUsername"
                            {...register("username", {
                              required: "Username is required.",
                            })}
                          />
                          {errors.username && (
                            <div className="invalid-feedback">
                              {errors.username.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <label htmlFor="yourPassword" className="form-label">
                          Password
                        </label>
                        <input
                          type="password"
                          name="password"
                          className={`form-control ${errors.password ? "is-invalid" : ""}`}
                          id="yourPassword"
                          {...register("password", {
                            required: "Password is required.",
                          })}
                        />
                        {errors.password && (
                          <div className="invalid-feedback">
                            {errors.password.message}
                          </div>
                        )}
                      </div>
                      {/* <div className="col-12">
                        <div className="form-check">
                          <input className="form-check-input" type="checkbox" name="remember" id="rememberMe" />
                          <label className="form-check-label" htmlFor="rememberMe">
                            Remember me
                          </label>
                        </div>
                      </div> */}
                      <div className="col-12">
                        <button className="btn btn-primary w-100" type="submit">
                          Login
                        </button>
                      </div>
                      {/* <div className="col-12">
                        <p className="small mb-0">
                          Don't have an account? <Link to="/register">Create an account</Link>
                        </p>
                      </div> */}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default Login;
